// extracted by mini-css-extract-plugin
export default {"inputBlock":"PasswordInput_inputBlock__DWyO-","button":"PasswordInput_button__YdmZ-"};